var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{staticStyle:{"margin":"'0px'","padding":"'0px'"},attrs:{"row":"","wrap":""}},_vm._l((_vm.gauges),function(gauge){return _c('Gauge',{key:gauge.i,staticStyle:{"margin":"'0px'","padding":"'0px'"},attrs:{"args":gauge,"size":_vm.size}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }